import React, { useState } from "react";
import { CloseDiv, HoverMe, ImgDiv, Panel } from "./styled";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import inst from "../../assets/images/inst.jpeg";
import fb from "../../assets/images/fb.png";
import tiktok from "../../assets/images/tt.png"; // твоя иконка TikTok
import { Link } from "react-router-dom";

export const LeftPanel = () => {
  const [openLeft, setOpenLeft] = useState(false);

  // --- Статические данные для социальных сетей ---
  const socialLinks = [
    { href: "https://www.instagram.com/mayyan_artiste?igsh=NTVka21yZ2pvN3Fv", src: inst, alt: "Instagram" },
    { href: "https://www.tiktok.com/@mayyan7771?_r=1&_t=ZS-93X7RvEAiuH", src: tiktok, alt: "TikTok" },
    { href: "https://www.facebook.com/share/1GjMPrcozo/?mibextid=wwXIfr", src: fb, alt: "Facebook" },
  ];

  return (
    <>
      <Panel $openLeft={openLeft}>
        <ImgDiv style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", paddingTop: "20px" }}>
          {socialLinks.map((social, index) => (
            <a key={index} href={social.href} target="_blank" rel="noopener noreferrer">
              <img
                src={social.src}
                alt={social.alt}
                style={{
                  width: "65px",
                  height: "65px",
                  objectFit: "contain",
                  borderRadius: "50%", // делает иконки круглым
                  transition: "transform 0.3s",
                }}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </a>
          ))}
        </ImgDiv>
      </Panel>

      <HoverMe
        onClick={() => setOpenLeft((prev) => !prev)}
        $openLeft={openLeft}
        style={{ zIndex: 1000 }}
      >
        {openLeft ? <IoIosArrowBack style={{ marginTop: "5px" }} /> : <IoIosArrowForward style={{ marginTop: "5px" }} />}
      </HoverMe>

      {openLeft && <CloseDiv onClick={() => setOpenLeft((prev) => !prev)} />}
    </>
  );
};
